import UserSingleSelect from "@/components/form/user-single-select";
import {
  makePickerField,
  type PickerFieldProps,
} from "@/fields/_internal/make-picker-field";

type UserFieldExtraProps = {
  /** List filters forwarded to the users list query (roles, isActivated, …). */
  params?: Record<string, unknown>;
  /** Render each option with its default account name under the user name. */
  showAccountName?: boolean;
  placeholder?: string;
  align?: "start" | "center" | "end";
};

export type UserFieldProps = PickerFieldProps<
  string | null,
  UserFieldExtraProps
>;

/**
 * Searchable single-user picker. Unlike {@link ManagerField} it applies no role
 * filter of its own — pass `params` to narrow the list.
 * **Value is a user id** (`string | null`).
 */
export const UserField = makePickerField<string | null, UserFieldExtraProps>({
  name: "UserField",
  control: UserSingleSelect,
  popout: true,
  controlProps: (props) => ({
    params: props.params,
    showAccountName: props.showAccountName,
    placeholder: props.placeholder ?? "Select user",
    align: props.align,
  }),
});
